import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import DashboardRoutes from "./dashboard/DashboardRoures";
import ProfileRoutes from "./profile/ProfileRoutes";

const App = () => {
  const [tokenProcessed, setTokenProcessed] = useState(false);

  useEffect(() => {
    const location = window.location;
    const urlParams = new URLSearchParams(location.search);
    const paramKeys = { token: "token" };

    Object.keys(paramKeys).forEach((key) => {
      paramKeys[key] = urlParams.get(key)
        ? decodeURIComponent(urlParams.get(key))
        : null;
    });

    if (typeof paramKeys.token === "string") {
      localStorage.setItem("token", paramKeys.token);

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("token");
      window.history.replaceState({}, document.title, newUrl.toString());
    }

    setTokenProcessed(true);
  }, []);

  if (!tokenProcessed) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/*" element={<DashboardRoutes />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
};

export default App;
